module.exports = __webpack_public_path__ + "img/pointtracker.24e2a1a0.svg";